function myFunction(){
  var quentityvaluee = $('.js-product-quantity input').val();
    quentityvaluee =parseInt(quentityvaluee);
    var variant_data_stock = $('[data-js-product-variants] option:selected').data('stock');
    if(variant_data_stock < quentityvaluee){
      $('.stock_checker_popup').show();
    }
    else{
      $('.stock_checker_popup').hide();
    }
}
$(document).ready(function(){
  
  //cart js 
  $(".cart-item-handle").each(function(){
    var current = $(this).val();
    var qty=$(this).attr("data-inv");
    if(current == "4627287965756" && qty < 25 ){
$(".custom-checkout-btn").attr('disabled', true);
 return false;
} 
    else if(current == "4333488209980" && qty < 3 ) {
    $(".custom-checkout-btn").attr('disabled', true);
   return false;
    }
     else if(current == "6252577292471" && qty < 3 ) {
    $(".custom-checkout-btn").attr('disabled', true);
   return false;
    }
      else if(current == "6252586336439" && qty < 5 ) {
    $(".custom-checkout-btn").attr('disabled', true);
   return false;
    }
    
     
else{
$(".custom-checkout-btn").attr('disabled', false);

}
  });
  
  //
  
  
   var pid = $('.js-product-quantity input').attr("data-pid");
  if(pid == 4627287965756 || pid == 4333488209980 || pid == 6252577292471 || pid == 6252586336439){
   var findRev = setInterval(function(){
  $('.swym-btn-container button').attr('disabled', true);      
       clearInterval(findRev);

    },1000);
  $('.jt-button-add-to-cart').attr('disabled', true);
  $('.new_custom_continue_checkout').attr('disabled', true);
  
  
   $('.js-product-options').click(function(){
    customizationEnable();  
 
    });
  }
  $('.acc_logged').click(function(e){
    e.preventDefault();
    $(this).find('.acc_popup').slideToggle();
  });
  if($('body').hasClass('template-index')){
    $('#MainContent .shopify-section').each(function(i){
      $(this).addClass('home-section-'+(i+1));
    });
  }
  if($('body').hasClass('template-product')){
    $('.js-product-quantity .cursor-pointer.plus').click(function(){
      var quentityvaluee = $('.js-product-quantity input').val();
      quentityvaluee =parseInt(quentityvaluee)+1;
      var variant_data_stock = $('[data-js-product-variants] option:selected').data('stock');
      if(variant_data_stock < quentityvaluee){
        $('.stock_checker_popup').show();      
      }
      customizationEnable();
    });
    $('.js-product-quantity .cursor-pointer.minus').click(function(){
      var quentityvaluee = $('.js-product-quantity input').val();
      quentityvaluee =parseInt(quentityvaluee)-1;
      var variant_data_stock = $('[data-js-product-variants] option:selected').data('stock');
      if(variant_data_stock >= quentityvaluee){
        $('.stock_checker_popup').hide();
      }
      else{
        $('.stock_checker_popup').show();
      }
      customizationEnable();
    });
    $('.js-product-quantity input').keyup(function(){
      var quentityvaluee = $('.js-product-quantity input').val();
      quentityvaluee =parseInt(quentityvaluee);
      var variant_data_stock = $('[data-js-product-variants] option:selected').data('stock');
      if(variant_data_stock < quentityvaluee){
        $('.stock_checker_popup').show();
      }
      else{
        $('.stock_checker_popup').hide();
      }
      customizationEnable();
    });
    $('.stock_checker_popup .cross').click(function(){
      $('.stock_checker_popup').hide();
    });
    
    //add to cart 
    $('.ps_select_outer .ps_select_each select').change(function(){
      //add class to engraving products
      var s_val = $(this).val();
      if(s_val){
        $(this).addClass('ps_select_add');
      }
      else{
        $(this).removeClass('ps_select_add');
      }
    });
    
    $('.jt-button-add-to-cart').click(function(e){
      e.preventDefault();
      var $this = $(this);
      var qty_check = parseInt($('.jt-input-quantity').val());
      var stock_qty=$('[data-js-product-variants]').val();
      var new_stock_qty=$('[data-js-product-variants]').find('[value="'+stock_qty+'"]').attr('data-stock');
      if(qty_check >= 20 && new_stock_qty >= qty_check){
        var engVarArr= [];
        var engQtyArr= [];
        $('.ps_select_add').each(function(){
          var fv_vid1 = $(this).find('option:selected').attr('data-var1-id');
          var fv_vid2 = $(this).find('option:selected').attr('data-var2-id');
          var fv_hasqty1 = 1;
          var fv_hasqty2 = parseInt($('.jt-input-quantity').val());
          engVarArr.push(fv_vid1);
          engVarArr.push(fv_vid2);
          engQtyArr.push(fv_hasqty1);
          engQtyArr.push(fv_hasqty2);
        });
        console.log(engVarArr);
        console.log(engQtyArr);
        console.log(engVarArr.length);
        if(engVarArr.length == 0){
          
          addRegularItem($this);
        }
        else{
          addEngraveItem(engVarArr, engQtyArr);
        }
        
      }
      else{
        $('.ps_select_each select').find('option:first').attr('selected', true);
        $('.cl_properties').html('');
        $('.product__customisation .file_up_name').hide();
        addRegularItem($this);
      } 
    });
  }
  if($('body').hasClass('template-cart')){
    $('.update-cartpage input').change(function(){
      var cp_product_qty = $(this).val();
      var cp_product_inventery= $(this).data('stock');
      showstockpopup(cp_product_qty,cp_product_inventery,$(this));
    });
    $('.update-cartpage input').keyup(function(){
      var cp_product_qty = $(this).val();
      var cp_product_inventery= $(this).data('stock');
      showstockpopup(cp_product_qty,cp_product_inventery,$(this));
    });
    $('.cart_stock_checker_popup .cross').click(function(){
      $(this).parent('.cart_stock_checker_popup').hide();
    });
    
    //engraving cart
    $('.cart_item_row.item_has_engr .cart_qty').keyup(function(e){
      e.preventDefault();
      var qqty = $(this);
      multiQuantity(qqty);
    });

    $('.cart_item_row.item_has_engr .cart_qty').change(function(e){
      e.preventDefault();
      var qqty = $(this);
      multiQuantity(qqty);
    });

    $('.cart_item_row.item_has_engr .cart_remove_item').click(function(e){
      var has_prop = $(this).parents('.cart_item_row').data('line-prop');
      var line_num = $(this).parents('.cart_item_row').data('line');
      //console.log(has_prop);      
      if(has_prop == 0){}
      else{
        e.preventDefault();
        var lineArr = [];
        lineArr.push(line_num);
        $('.cart_item_row').each(function(i){
          var has_parent = $(this).data('parent-item');
          var cr_line = $(this).data('line');
          var indx = i+1;
          //console.log(indx);          
          if(indx > line_num){
            if(has_parent){
              //console.log('engraving');
              lineArr.push(cr_line);
            }
            else{
              //console.log('regular');
              return false;
            }
          }          
        });
        //console.log(lineArr);
        multiRemoveFromCart(lineArr);
      }
    });
  }
  
  var pathname = window.location.pathname;
  if(pathname == '/account/register'){
  window.location.replace("/account/login");
  }
  
  $('.responsive-table-row .cancel_order').click(function(){
    $('.cancle-order-popup').toggle();
  });
  $('.cancle-order-popup .cross').click(function(){
    $('.cancle-order-popup').hide();
  });
  
  var referrer =  document.referrer;
  if(referrer.indexOf("/cart") != -1){
    $('.dealer-redirect').val(referrer);
  }
 
});

$(window).load(function(){
  var buynow = $('.shopify-payment-button__button').text();
  //console.log(buynow);
  if(buynow == 'Buy it now'){
    $('.shopify-payment-button__button').text('Buy Now');
  }
});
function showstockpopup(line_item_qty,line_item_inventery,present){
  if(line_item_inventery < line_item_qty ){
    $(present).parents('.cp-stock-checker').find('.cart_stock_checker_popup').show();
  }
  else{
    $(present).parents('.cp-stock-checker').find('.cart_stock_checker_popup').hide();
  }

}

function customizationEnable(){  
  setTimeout(function(){
   var qty =  parseInt($('.js-product-quantity input').val());
    var pid = $('.js-product-quantity input').attr("data-pid");
    if(pid == 4627287965756 ){
      var num = 25;
    }
    else if(pid == 4333488209980 ){
     var num = 3;
    }
    else if(pid == 6252577292471 ){
    var num = 3;
    }
      else if( pid == 6252586336439){
    var num = 5;
    }
    
      else{
  var num = 20;
  }
    if(qty >= num){
       if(pid == 4627287965756 || pid == 4333488209980  ||pid == 6252577292471 || pid == 6252586336439){
      $('.jt-button-add-to-cart').attr('disabled', false);
       $('.new_custom_continue_checkout').attr('disabled', false);
        $('.swym-btn-container button').attr('disabled', false);
          }

      $('.ps_select_outer select').attr('disabled', false);
      if($('.file_up_input').hasClass('file_input_disabled')){
        $('.file_up_input').removeClass('file_input_disabled');
      }
      $('.pops').hide();
       $('.ps_select_each').find('div').removeClass("overlay1"); 
    }
    else{
       if(pid == 4627287965756 || pid == 4333488209980  ||pid == 6252577292471 || pid == 6252586336439){
      $('.swym-btn-container button').attr('disabled', true);  
      $('.new_custom_continue_checkout').attr('disabled', true);
       $('.jt-button-add-to-cart').attr('disabled', true);
       }
     
      $('.ps_select_outer select').attr('disabled', true);
      $('.file_up_input').addClass('file_input_disabled');
       $('.ps_select_each').find('div').addClass("overlay1"); 
    }
  }, 200);
}

function addRegularItem(item){
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: $(item).parents('form[action="/cart/add"]').serialize(),
    dataType: 'json',
    success: function() { 
      window.location.href = '/cart';
    },
    error: function (error) {      
      alert(error.responseJSON['description']);
    }
  });
}

function addEngraveItem(idArr, qtyArr){
  var e_id = idArr.shift();
  var e_qty = qtyArr.shift();
  var name_pro = $('.jt-input-quantity').attr('data-title');
  var ran_num = Math.floor(Math.random() * (+999 - +1)) + +1

  data = {
    "quantity": e_qty,
    "id": e_id,
    "properties[Product]": name_pro,
    "properties[_customization]": ran_num
  }
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() { 
      if(idArr.length == 0){
        var add_btn = $('.jt-button-add-to-cart');
        addRegularItem(add_btn);
      }
      else{
        addEngraveItem(idArr, qtyArr);
      }      
    },
    error: function (error) {      
      alert(error.responseJSON['description']);
    }
  });
}

function multiRemoveFromCart(line_Arr){
  var line_id = line_Arr.pop();
  $.ajax({
    type: 'POST',
    context: this,
    url: '/cart/change.js',
    data: { quantity: 0, line: line_id } ,
    dataType: 'json',
    success: function() { 
      if(line_Arr.length == 0){
        window.location.href= '/cart';
      }
      else{
        multiRemoveFromCart(line_Arr);
      }
    },
    error: function(){
      setTimeout(function(){
        //window.location.href= '/cart';
      },500);
    }
  });
}

function multiQuantity(item){

  var ath = parseInt(item.data('min'));
  var avl = parseInt(item.val());
  if(avl < ath){
    item.val(ath);
  }

  var dataChild = item.attr('data-child');
  var dataCurrent = item.attr('data-current');

  var qtyArr = [];
  var qty_num = item.parents('.cart_item_row').data('line');

  $('.cart_item_row').each(function(i){
    var has_parent = $(this).data('parent-item');
    var cr_line = $(this).data('line');
    var indx = i+1;
    //console.log(indx);          
    if(indx > qty_num){
      if(has_parent){
        //console.log('engraving');
        qtyArr.push(cr_line);
      }
      else{
        return false;
      }
    }          
  });
var dataa=qty_num + 1;
  console.log(qtyArr);
  var i;
  for (i = 0; i < qtyArr.length; i++) { 
   
    if(dataChild != '' && dataCurrent != ''){
item.parents('.cart__items').find('[data-line="'+dataa+'"] .text-sm-left.cart_qty').val(item.val());
      $('.'+dataChild+'[data-line="'+qtyArr[i]+'"]'+' [data-parent="'+dataCurrent+'"]').val(item.val());
    }
  }
}

function callbacktop(){
    $('.footer__back-to-top').trigger('click');
}

$(document).ready(function(){
  $('.account_login_tabs li a').click(function(){
    $('.login_active').removeClass('login_active');
    $(this).addClass('login_active');
  });
  $('a.vecvemployee').click(function(){
   $("div#tab-1").fadeIn();
    $('div#tab-2').fadeOut()
  });
    $('a.dealers').click(function(){
  $("div#tab-2").fadeIn();
    $('div#tab-1').fadeOut()
  });
  $('a.dealeremployees').click(function(){
  $("div#tab-3").fadeIn();
    $('div#tab-2').fadeOut()
  });

});

$(document).ready(function(){
  /*************** remove d-none class frome slider *****************/

  	$('.slick-dots').removeClass('d-none');
 jQuery('.banner-custom-text').click(function(){
var url=jQuery(this).parent().find('.promo-text__buttons a').attr('href');
window.location.href=url;

});
});


 // Cookies
function setCookie(cname,cvalue,exdays) {
  var cookies_date = new Date();
  cookies_date.setTime(cookies_date.getTime() + (exdays*24*60*60*1000));
  var expires = "expires=" + cookies_date.toGMTString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
  var cookies_name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var decode_cookies = decodedCookie.split(';');
  for(var i = 0; i < decode_cookies.length; i++) {
    var cokkies_found = decode_cookies[i];
    while (cokkies_found.charAt(0) == ' ') {
      cokkies_found = cokkies_found.substring(1);
    }
    if (cokkies_found.indexOf(cookies_name) == 0) {
      return cokkies_found.substring(cookies_name.length, cokkies_found.length);
    }
  }
  return "";
}